import apiClient from "../../apiClient";
import {
  FillTransaction,
  FillTransactionCreate,
  TableTransferCreate,
  FillTransactionListResponse,
  TableBalanceResponse,
  FillTransactionFilters,
} from "./type";
import { GameTable } from "../gameTables/type";

const BASE_URL = "/fills";

export const fillTransactionService = {
  // Create a new fill transaction
  createFillTransaction: async (
    data: FillTransactionCreate,
  ): Promise<FillTransaction> => {
    const response = await apiClient.post(BASE_URL, data);
    return response.data;
  },

  // Create a table-to-table transfer
  createTableTransfer: async (
    data: TableTransferCreate,
  ): Promise<{
    fill_in_transaction: FillTransaction;
    fill_out_transaction: FillTransaction;
  }> => {
    const response = await apiClient.post(`${BASE_URL}/table-transfer`, data);
    return response.data;
  },

  // Get list of fill transactions with filters
  getFillTransactions: async (
    filters?: FillTransactionFilters,
  ): Promise<FillTransactionListResponse> => {
    const params = new URLSearchParams();

    if (filters) {
      if (filters.status) params.append("status", filters.status);
      if (filters.transaction_type)
        params.append("transaction_type", filters.transaction_type);
      if (filters.table_id) params.append("table_id", filters.table_id);
      if (filters.shift) params.append("shift", filters.shift);
      if (filters.date_from) params.append("date_from", filters.date_from);
      if (filters.date_to) params.append("date_to", filters.date_to);
      if (filters.page) params.append("page", filters.page.toString());
      if (filters.page_size)
        params.append("page_size", filters.page_size.toString());
    }

    const response = await apiClient.get(`${BASE_URL}?${params.toString()}`);
    return response.data;
  },

  // Get a specific fill transaction by ID
  getFillTransaction: async (id: string): Promise<FillTransaction> => {
    const response = await apiClient.get(`${BASE_URL}/${id}`);
    return response.data;
  },

  // Approve a pending fill transaction
  approveFillTransaction: async (
    id: string,
    notes?: string,
  ): Promise<FillTransaction> => {
    const response = await apiClient.put(`${BASE_URL}/${id}/approve`, {
      notes,
    });
    return response.data;
  },

  // Reject a pending fill transaction
  rejectFillTransaction: async (
    id: string,
    reason: string,
  ): Promise<FillTransaction> => {
    const response = await apiClient.put(`${BASE_URL}/${id}/reject`, {
      reason,
    });
    return response.data;
  },

  // Complete an approved fill transaction
  completeFillTransaction: async (
    id: string,
    notes?: string,
  ): Promise<FillTransaction> => {
    const response = await apiClient.put(`${BASE_URL}/${id}/complete`, {
      notes,
    });
    return response.data;
  },

  // Get table balance
  getTableBalance: async (tableId: string): Promise<TableBalanceResponse> => {
    const response = await apiClient.get(
      `${BASE_URL}/tables/${tableId}/balance`,
    );
    return response.data;
  },

  // Get all game tables
  getGameTables: async (): Promise<GameTable[]> => {
    const response = await apiClient.get("/game-tables");
    return response.data;
  },
};
